import LandingPage from 'components/pages/Landing';

import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getCouponFeaturedStoresList } from 'services/coupon';
import {
  getLandingInfo,
  getLandingOffersList,
  getLandingsList,
} from 'services/landing';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LANDINGS from 'constants/landings';
import LINKS from 'constants/links';

const InstitucionalLanding = (props) => (
  <LandingPage
    offersListProps={{ showButtonBeforeFirstPagination: true }}
    {...props}
  />
);

export const getServerSideProps = async ({ query: { landingSlug } }) => {
  try {
    const [
      { landing },
      initialOffers,
      storesWithFeaturedCoupons,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getLandingInfo({ landingSlug }),
      getLandingOffersList({
        landingSlug,
        limit: LANDINGS.OFFERS_SERVER_LIMIT,
      }),
      {
        fn: getCouponFeaturedStoresList(),
        fallback: getCouponFeaturedStoresList.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    if (landing.landingType !== LANDINGS.TYPES.INSTITUTIONAL) {
      return { redirect: { destination: LINKS[404], permanent: false } };
    }

    return {
      props: {
        initialOffers,
        landing,
        storesWithFeaturedCoupons,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default InstitucionalLanding;
